export const LocalPath = {
  request_otp: "/auth/get_otp",
};

export const DevPath = {
  request_otp: "/auth/get_otp",
  verify_otp: "/auth/verify_otp",
  store_details: "/store/open/details",
  store_details_refresh: "/store/open/details_refresh",
  store_data: "/store/open/all_store_products_filter",
  store_filter: "/store/open/filters",
  view_categories: "/store/open/all_hct_products",
  view_categories_new: "/store/open/all_store_products_by_hct",
  view_product_details: "/product/open/get_by_id",
  search_product_list: "/product/open/search",
  get_cart_products: "/cart/open/get_cart",
  update_cart_quantity: "/cart/open/update_cart",
  delete_cart_product: "/cart/open/delete_cart",
  add_cart_products: "/cart/open/add",
  get_faqs: "/store/open/get_faqs",
  prc_to_cart: "/cart/convert_prsc_to_cart",
  co_to_cart: "/cart/open/convert_co_to_cart",
  get_prc_data: "/order/open/user_details_by_co_or_pres_no",
  cart_to_order: "/order/convert_cart_to_order",
  create_order: "/order/create_order",
  create_cart_order: "/order/create_order_from_cart",
  confirm_order: "/order/confirm_order",
  get_orders: "/order/all_orders",
  get_order_detail: "/order/order_details",
  get_order_detail_number: "/order/order_details_by_ord_number",
  get_cart_count: "/cart/open/get_cart_count",
  cancel_order: "/order/cancel_order",
  cancel_order_reasons: "/order/cancel_order_reasons",
  return_order_reasons: "/order/return_order_reasons",
  return_order: "order/return_order",
  add_to_wishlist: "/wishlist/add_to_wishlist",
  get_wishlist: "/wishlist/get_wishlist",
  delete_wishlist_item: "/wishlist/delete_wishlist",
  update_wishlist_quantity: "/wishlist/update_wishlist",
  add_wishlist_cart: "/wishlist/convert_to_cart",
  get_address: "/cart/get_shipping_address",
  save_address: "/cart/save_shipping_address",
  postal_codes: "/cart/open/pincode",
  del_save_address: "/cart/delete_shipping_address",
  pincode_check_availability: "/product/open/check_availability",
  get_order_payment_types: "/order/order_payment_types",
  payment_status_by_order_no: "/order/payment_status_by_order_no",
  new_mystore: "/store/open/all_health_concerns_by_category",
};
const env = process.env.REACT_APP_ENV || "local";
export const Paths = (() => {
  switch (env) {
    case "local":
      return LocalPath;
    case "development":
    default:
      return DevPath;
  }
})();
